import React from "react";

const Revenues = () => {
  return <div>Revenues</div>;
};

export default Revenues;
